<div class="row">
	<div class="table-responsive">
		<table class="table table-borderless mb-0" style="width: fit-content">
			<tbody>
				<tr style="width: 50%">
					<th class="ps-0">Numéro BC :</th>
					<td class="text-muted">{{ numero }}</td>
				</tr>
				<tr style="width: 50%">
					<th class="ps-0">Date du reception :</th>
					<td class="text-muted">{{ date }}</td>
				</tr>
				<tr style="width: 50%">
					<th class="ps-0">fournisseur :</th>
					<td class="text-muted">{{ fournisseur }}</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>
